// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"mo-z","badgeLink":"no-z","category":"oo-z"};